import { Link } from "react-router-dom";
import { Button, Steps } from "antd";
import { PhoneOutlined, QuestionCircleOutlined } from "@ant-design/icons";

function SideMenu({
  styleColor,
  link,
  title2,
  title1,
  hasContact,
  content,
  hasSteps,
  items,
}) {
  return (
    <div className="flex max-lg:z-[1000] flex-col items-center justify-start sticky top-2">
      <div className=" sideMenuSection1 flex flex-col max-lg:flex-row max-lg:w-full w-[25%] px-4 py-4 justify-start items-center">
        <div className=" weatherCard box-shadow rounded-2xl agrobg flex flex-col max-lg:flex-col p-3 max-lg:p-2 gap-2 max-lg:gap-0 w-[14rem] max-lg:w-full items-center justify-between">
          <div className="Visit agrobg flex flex-row max-lg:flex-row-reverse gap-4 py-4 max-lg:py-2 max-lg:px-3 w-full items-center justify-end">
            <div className="flex flex-col max-lg:mx-0 mx-auto">
              <p
                className={` text-right tracking-tight font-extrabold ${styleColor} `}
              >
                {title1}
              </p>
            </div>
          </div>

          <div className="flex flex-col max-lg:!w-full gap-0 justify-start lg:items-end max-lg:p-2 max-lg:gap-2">
            <p className="text-right text-[12px] max-lg:text-[10px] max-lg:text-justify">
              {content}
            </p>

            {hasSteps && (
              <Steps
                className="text-xs w-[200px] tracking-tight "
                direction="vertical"
                size="small"
                items={items}
              />
            )}

            {hasContact && (
              <p className="text-left text-[12px] translate-x-4">
                <span>
                  {" "}
                  09155599612 , 05191004601{" "}
                  <PhoneOutlined
                    className={`text-[22px] flip ${styleColor}`}
                  />{" "}
                </span>
              </p>
            )}
          </div>

          {link && (
            <Link to={link} target="blank">
              <Button
                icon={<QuestionCircleOutlined />}
                className={`flex items-center text-[13px] button-neo3 hover:brightness-105 ${styleColor} font-bold `}
              >
                {title2}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
